import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import 'aos/dist/aos.css';
import AOS from 'aos';

// Layouts
import MainLayout from './layouts/MainLayout.jsx';
import AdminLayout from './layouts/AdminLayout.jsx';

// Protected Route
import ProtectedRoute from './components/admin/ProtectedRoute.jsx';

// Public Pages
import HomePage from './pages/HomePage.jsx';
import ProductsPage from './pages/ProductsPage.jsx';
import ProductDetailPage from './pages/ProductDetailPage.jsx';

import AccessoriesPage from './pages/AccessoriesPage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import WishlistPage from './pages/WishlistPage.jsx';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin.jsx';

import ForgotPassword from './pages/admin/ForgotPassword.jsx';
import ResetPassword from './pages/admin/ResetPassword.jsx';
import AdminDashboard from './pages/admin/AdminDashboard.jsx';
import ProductManagement from './pages/admin/ProductManagement.jsx';
import ProductForm from './pages/admin/ProductForm.jsx';
import CategoryManagement from './pages/admin/CategoryManagement.jsx';
import BrandManagement from './pages/admin/BrandManagement.jsx';
import BannerManagement from './pages/admin/BannerManagement.jsx';
import InventoryManagement from './pages/admin/InventoryManagement.jsx';
import SalesManagement from './pages/admin/SalesManagement.jsx';
import SalesForm from './pages/admin/SalesForm.jsx';
import ExpenseManagement from './pages/admin/ExpenseManagement.jsx';
import ExpenseForm from './pages/admin/ExpenseForm.jsx';
import CustomerManagement from './pages/admin/CustomerManagement.jsx';
import AdminProfile from './pages/admin/AdminProfile.jsx';
import ReportsPage from './pages/admin/ReportsPage.jsx';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
    });
  }, []);

  return (
    <Router>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
            borderRadius: '12px',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="products/:id" element={<ProductDetailPage />} />

          <Route path="accessories" element={<AccessoriesPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="wishlist" element={<WishlistPage />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin/secure-login" element={<AdminLogin />} />

        <Route path="/admin/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin/reset-password/:resetToken" element={<ResetPassword />} />
        <Route path="/admin" element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="products" element={<ProductManagement />} />
            <Route path="products/new" element={<ProductForm />} />
            <Route path="products/:id/edit" element={<ProductForm />} />
            <Route path="categories" element={<CategoryManagement />} />
            <Route path="brands" element={<BrandManagement />} />
            <Route path="banners" element={<BannerManagement />} />
            <Route path="inventory" element={<InventoryManagement />} />
            <Route path="sales" element={<SalesManagement />} />
            <Route path="sales/new" element={<SalesForm />} />
            <Route path="expenses" element={<ExpenseManagement />} />
            <Route path="expenses/new" element={<ExpenseForm />} />
            <Route path="expenses/:id/edit" element={<ExpenseForm />} />
            <Route path="customers" element={<CustomerManagement />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="profile" element={<AdminProfile />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;